import { useQuery } from '@tanstack/react-query'
import { fetchApi } from '@/common/lib/fetchApi'

export interface AdminPayPeriodDetail {
  id: number
  start_date: string
  end_date: string
  state: string
  submission_deadline: string
  payout_date: string | null
}

export interface SummaryCounts {
  total: number
  submitted: number
  approved: number
  draft: number
  rejected: number
  missing: number
}

export interface EmployeeTimesheetStatus {
  employee_id: number
  employee_name: string
  department: string | null
  company: string | null
  status: string
  total_hours: number
  standard_hours: number
  straight_overtime_hours: number
  flsa_overtime_hours: number
  timesheet_id: number | null
  manager_id: number | null
  manager_name: string | null
  work_email: string | null
  submitted_at: string | null
  approved_at: string | null
  is_admin_override: boolean
}

export interface AdminTimesheetSummary {
  pay_period: AdminPayPeriodDetail
  summary: SummaryCounts
  employees: EmployeeTimesheetStatus[]
}

export function useAdminTimesheetSummary(startDate?: string) {
  const params = startDate != null ? `?start_date=${startDate}` : ''
  return useQuery({
    queryKey: ['admin', 'timesheet-summary', startDate ?? 'default'],
    queryFn: () => fetchApi<AdminTimesheetSummary>(`/api/org/timesheets/summary${params}`),
  })
}

export function useAdminPayrollSummary(startDate?: string) {
  const searchParams = new URLSearchParams()
  if (startDate != null) searchParams.set('start_date', startDate)
  searchParams.set('employees_only', 'true')
  const qs = searchParams.toString()
  return useQuery({
    queryKey: ['admin', 'payroll-summary', startDate ?? 'default'],
    queryFn: () => fetchApi<AdminTimesheetSummary>(`/api/org/timesheets/summary?${qs}`),
  })
}

export interface EarliestPayPeriod {
  start_date: string
  end_date: string
}

export function useEarliestPayPeriod() {
  return useQuery({
    queryKey: ['admin', 'earliest-pay-period'],
    queryFn: () => fetchApi<EarliestPayPeriod | null>('/api/org/timesheets/earliest-pay-period'),
  })
}
